import {http} from 'utils/http';

export interface SignupInput {
	username: string;
	firstName: string;
	lastName: string;
	accType: string;
	email: string;
	password: string;
	rgpd: boolean;
	recaptcha: string;
	corporateFunction: string;
	preferredLanguage?: string;
}

export interface SignupSuccess {
	signup_token: string;
}

// ROUTE
export const apiSignupRoute = () => '/users/';

// API FUNCTION
export const apiSignup = (input: SignupInput) =>
	http.post<SignupSuccess>(apiSignupRoute(), input);
